// extracted by mini-css-extract-plugin
export var backdropBlur = "_lo-0";
export var contentCard = "_lo-5";
export var frame = "_lo-2";
export var image = "_lo-4";
export var imagePane = "_lo-3";
export var modal = "_lo-1";